import { PointFilters } from 'components';
import { connect } from 'react-redux';


export default connect (
	({ points: { filters, disabledFilters, date }, managers: { ids }, filters: { indicator, waiter } }) => ({ filters, disabledFilters, date, ids, indicator, waiter })
)( PointFilters );
